import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/overview/vendors",
)({
  staticData: {
    title: "Vendors",
    breadcrumbs: [{ title: "Overview", to: "/$slug/fleet/$aircraftId/overview" }],
  },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/overview/vendors.tsx"),
    "Vendors",
  ),
})
